import React, { useContext, useEffect, useState } from 'react';
import { Col, Row } from '@thd-olt-component-react/grid';
import { ExperienceContext } from '@thd-nucleus/experience-context';
import { SuperSkuMiniSwatches } from '@thd-olt-component-react/super-sku';
import { ProductATC } from '../product-atc/ProductATC';
import { ProductFavorites } from '../product-favorites/ProductFavorites';
import { ProductHeader } from '../product-header/ProductHeader';
import { ProductImage } from '../product-image/ProductImage';
import { ProductPodContext } from '../../ProductPodContext';
import { ProductPrice } from '../product-price/ProductPrice';
import { ProductQuantity } from '../product-quantity/ProductQuantity';
import { ProductRating } from '../product-rating/ProductRating';
import { ProductShipping } from '../product-shipping/ProductShipping';
import { ProductStore } from '../product-store/ProductStore';
import { isATCEnabled } from '../../utils';
import './product-side-by-side.style.scss';

export const ProductSideBySide = () => {
  const {
    channel,
  } = useContext(ExperienceContext);
  const {
    isATCDisabled,
    isHovered,
    itemId,
    onChangeSuperSku,
    onFavoriteChange,
    onHoverSuperSku,
    previousItemId,
    product,
    storeId,
  } = useContext(ProductPodContext);

  const [mounted, setMounted] = useState(false);
  useEffect(() => {
    setMounted(true);
  }, []);

  const isDisabled = isATCDisabled;
  const superSkuItemId = isHovered ? previousItemId : itemId;
  const isMobile = channel === 'mobile';

  return (

    <Row>
      <Col>
        <ProductHeader brand="inline" collection="hidden" />
      </Col>
      <Col fallback="6">
        <ProductImage className="product-image" />
        <ProductFavorites
          className="product-pod__inline__favorite"
          onFavoriteChange={onFavoriteChange}
          position="topRight"
          showCircle
        />
      </Col>
      <Col fallback="6" className="flex-column" nopadding>
        <ProductRating />
        <ProductPrice large={false} />
        {mounted && (
          <SuperSkuMiniSwatches
            itemId={superSkuItemId}
            storeId={storeId}
            onChange={onChangeSuperSku}
            onHover={onHoverSuperSku}
          />
        )}
        <ProductStore />
        <ProductShipping className="product-pod__fulfillment--shipping-collection" />
        { isATCEnabled(product) && (
          <Col className="atc-wrapper" nopadding>
            { !isMobile && (
              <Col
                xs="3"
                nopadding
              >
                <ProductQuantity textOnly />
              </Col>
            ) }
            <Col
              xs="7"
              nopadding
            >
              <ProductATC outline disabled={isDisabled} />
            </Col>
          </Col>
        )}
      </Col>
    </Row>
  );
};

ProductSideBySide.displayName = 'ProductPodSideBySide';
